import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import {MdCheckbox, MdTextField} from 'core/components/fields/fields';
import Axios from 'core/common/config/axios-config';
import Grid, {FILTEROPERATOR, GridLocation, GRIDTYPE} from 'core/grid/domain/grid';
import GridConfig from 'core/grid/domain/gridConfig';
import GridConfigCondition from 'core/grid/domain/gridConfigCondition';
import GridConfigSort, {SORTORDER} from 'core/grid/domain/gridConfigSort';
import gridService from 'core/grid/gridService';
import ConditionValueForm, {CONDITIONVALUEFORMCONTEXT} from 'core/grid/component/conditionValueForm';
import {ErrorComp} from 'core/components/errorComp/errorComp';
import {BlockComp, MdDivider} from 'core/components/blockComp/blockComp';
import LocalizeField from 'core/components/fields/localizeField';
import ColumnSelector from 'core/grid/component/columnSelector';
import StyledSelect from 'core/components/fields/styledSelect';
import {fieldStyles} from 'core/form/createForm';
import {lovValue, TExtractFieldFn} from 'core/form/formUtils';
import Add from "material-ui/svg-icons/content/add";
import {action, isArrayLike, observable, ObservableMap} from "mobx";
import MdEntity, {LovItem} from "core/metamodel/mdEntity";
import {AxiosResponse} from "axios";
import {observer} from "mobx-react";
import Form from "core/form/form";
import GridConfigColumn from "core/grid/domain/gridConfigColumn";
import uiService from "core/common/service/uiService";
import mdEntityService from "core/metamodel/mdEntityService";
import {removeItemFromLocalStorage} from "core/common/utils/storage";
import RadioButtonField from "core/components/fields/radioButtonField";
import securityService from "core/security/securityService";
import {CONFIGLEVEL} from "core/metamodel/metaConstant";
import {loc} from "core/common/config/locales";
import SqlSelectDialog from "core/components/dialogs/sqlSelectDialog";
import mdField from "core/metamodel/mdField";
import isEmpty = require("lodash/isEmpty");
import remove = require("lodash/remove");
import isEqual = require("lodash/isEqual");


interface GridAdminCompProps {
  grid?: Grid;
  gridLocation: GridLocation;
  gridConfig: GridConfig;
  entities: ObservableMap<MdEntity>;
  adminMode?: boolean;
}

interface TIndexColumn {
  columnName: string;
  sortOrder: SORTORDER;
}

interface TIndex {
  indexName: string;
  columns: TIndexColumn[];
}


@observer
export default class GridAdminComp extends React.Component<GridAdminCompProps, undefined> {

  private sqlSelectDialogRef: SqlSelectDialog;

  @observable indexes: TIndex[];

  componentDidMount() {
    const {gridConfig, gridLocation} = this.props;
    if (gridConfig.sortColumns && gridConfig.sortColumns.length && gridLocation.entityName) {
      return Axios.get("/core/meta/entity/" + gridLocation.entityName + "/indexes")
        .then(action("indexes-read-action", (response: AxiosResponse) => {
          this.indexes = response.data;
        }));
    }
  }


  @action save() {
    let {grid, gridLocation, gridConfig} = this.props;

    // odstranim prazdne sloupce
    remove<GridConfigColumn>(gridConfig.columns, v => !v.field);

    // predelam na lovValue
    for(let condition of gridConfig.conditions) {
      if (isArrayLike(condition.values))  {
        condition.values = condition.values.map(v => lovValue(v));
      }
    }

    if (lovValue(gridConfig.configLevel) === CONFIGLEVEL.USER) {
      gridConfig.user = securityService.currentUser.createLov();
    }

    if (this.validate()) {
      uiService.showToolbarActionFlag();
      return Axios.post('/core/grid-config', gridConfig)
        .then(action("save-callback", (response: AxiosResponse) => {
          let newGridConfig = new GridConfig(gridLocation, response.data);
          newGridConfig.gridWidths = gridService.computeGridWidths(null, newGridConfig);
          gridService.gridConfig = newGridConfig;
          if (grid) grid.replaceGridConfig(newGridConfig);
          removeItemFromLocalStorage("GridLocation", loc.lang, newGridConfig.gridLocation);
          uiService.hideToolbarActionFlag();
          return newGridConfig;
        }));
    } else {
      return Promise.resolve(null);
    }

  };

  pushIfTrue(array, value) {
    if (value) array.push({message:value});
  }

  @action validate() {
    let {gridConfig, entities} = this.props;
    gridConfig.$errors = [];

    this.pushIfTrue(gridConfig.$errors, this.validateGridConfigName());
    this.pushIfTrue(gridConfig.$errors, this.validateGridScrollSize());
    this.pushIfTrue(gridConfig.$errors, this.validateGridPageSize());
    this.pushIfTrue(gridConfig.$errors, this.validateMaxColumnWidth());
    this.pushIfTrue(gridConfig.$errors, this.validateHardRowLimit());


    if (isEmpty(gridConfig.columns)) {
      gridConfig.$errors.push({message: loc.i18n`At least one column must be selected.`});
    }

    let allOperators = entities.get('FILTEROPERATOR').lovItems;

    gridConfig.conditions.forEach((condition, index) => {
      let form = condition.getForm('ConditionValueForm');
      form.validateForm(condition, gridConfig.$errors);
      gridService.validateCondition(condition, gridConfig.$errors, index, allOperators);
    });
    gridConfig.sortColumns.forEach((sortColumn, index) => gridService.validateSortColumn(gridConfig.sortColumns, sortColumn, gridConfig.$errors, index));


    switch (lovValue(gridConfig.configLevel)) {
      case CONFIGLEVEL.USER:
        if (!gridConfig.user) gridConfig.$errors.push({message: loc.i18n`For User Grid, user must be selected.`});
        break;
      case CONFIGLEVEL.TENANT:
        if (!gridConfig.tenant) gridConfig.$errors.push({message: loc.i18n`For Tenant Grid, Tenant must be selected.`});
        break;
      case CONFIGLEVEL.TENANTGROUP:
        if (!gridConfig.tenantGroup) gridConfig.$errors.push({message: loc.i18n`For Tenant Group Grid, Tenant Group must be selected.`});
        break;
    }

    return isEmpty(gridConfig.$errors);
  }




//  text fields change handlers
  @action onChangeTextField(fieldName, isNumber, evt) {
    let {gridConfig} = this.props;
    console.debug('onChangeTextField %s, value = %s', fieldName, evt.target.value);
    gridConfig[fieldName] = evt.target.value;
  }

  @action onChangeCheckbox(fieldName, evt, checked) {
    let {gridConfig} = this.props;
    console.debug('onChangeCheckbox %s, evt = %o, checked = %o', fieldName, evt, checked);
    gridConfig[fieldName] = checked;
  }

  @action onChangeSelect(fieldName, value) {
    let {gridConfig} = this.props;
    console.debug('onChangeSelect %s, value = %s', fieldName, value);
    gridConfig[fieldName] = value;
  }

  @action validateTextField(fieldName: string, message: string, isPositiveNumber?: boolean, required: boolean = true) {
    let {gridConfig} = this.props;

    let value = gridConfig[fieldName];

    console.debug('validateTextField %s, value = %s', fieldName, value);

    if (!value && !required) {
      return null;
    }

    let error: string;
    if (isPositiveNumber) {
      value = parseInt(value);
      if (!Number.isInteger(value)) {
        error = message;
      } else if (value < 0) {
        error = message;
      }
    } else if (!value) {
      error = message;
    }
    gridConfig.$errorMap.set(fieldName, error);
    return error;
  }


  validateGridConfigName = () => this.validateTextField('gridName', loc.i18n`Name of grid is required.`);
  onBlurGridConfigName = () => {
    this.validateGridConfigName();
  };
  validateGridScrollSize = () => this.validateTextField('gridScrollSize', loc.i18n`Grid scroll size is required positive number.`, true);
  onBlurGridScrollSize = () => {
    this.validateGridScrollSize();
  };
  validateGridPageSize = () => this.validateTextField('gridPageSize', loc.i18n`Grid page size is required positive number.`, true);
  onBlurGridPageSize = () => {
    this.validateGridPageSize();
  };
  validateMaxColumnWidth = () => this.validateTextField('maxColumnWidth', loc.i18n`Max column widh is required positive number.`, true);
  onBlurMaxColumnWidth = () => {
    this.validateMaxColumnWidth();
  };
  validateHardRowLimit = () => this.validateTextField('hardRowLimit', loc.i18n`Hard row limit is required positive number.`, true, false);
  onBlurHardRowLimit = () => {
    this.validateHardRowLimit();
  };



  @action onClickAddFilter = (evt) => {
    console.log('onClickAddFilter');
    let {gridConfig} = this.props;

    let condition = new GridConfigCondition(gridConfig, null);
    gridConfig.conditions.push(condition);
  };

  @action onChangeConditionColumn(condition: GridConfigCondition, newColKey: string) {
    newColKey = lovValue(newColKey);
    console.log('onChangeConditionColumn: ', newColKey, condition);
    let {gridConfig} = this.props;
    condition.field = gridConfig.getEntityRef().getFieldByKey(newColKey);
    condition.operator = null;
    condition.values = [];

    return gridService.fetchConditionLovs([condition])
      .then(entityMap => {
        this.setupConditionField(condition, false);
      });
  };

  setupConditionField = (condition: GridConfigCondition, setValues: boolean) => {
    let form: Form<any> = condition.getForm("ConditionValueForm");
    console.log('setupConditionField field0.props.value = %O, options = %O', form.fields["field0"].props.value,  form.fields["field0"].props.options);
    form.fields = form.setupFields(condition, gridService.gridConfig, condition.getEntityRef(), this.props.entities, this.extractFieldFn);
    if (setValues) {
      form.updateAllFieldsPropValue(condition);
    }
    console.log('setupConditionField field0.props.value = %O, options = %O', form.fields["field0"].props.value,  form.fields["field0"].props.options);
  };


  @action onChangeConditionOperator(condition: GridConfigCondition, newOperator) {
    newOperator = lovValue(newOperator);
    console.log('onChangeConditionOperator: ', newOperator, condition);
    let {gridConfig, entities} = this.props;
    condition.operator = newOperator;

    if (newOperator) {
      let allOperators = entities.get('FILTEROPERATOR').lovItems;
      let operatorLov = allOperators.find(v => v.value === newOperator);

      if (operatorLov["inputCount"] === 'N') {
        condition.values = [];
      } else {
        condition.values = new Array(parseInt(operatorLov["inputCount"] as string));
      }
    } else {
      condition.values = [];
    }
    condition.getForm("ConditionValueForm").updateFieldsPropValue(condition, "field0", "field1", "fieldMulti");
  };

  @action onChangeSearchTermOperator(field: mdField, newOperator) {
    newOperator = lovValue(newOperator);
    console.log('onChangeSearchTermOperator: ', newOperator, field);
    field.searchTermType = newOperator;
  };

  @action onCheckSuperFilter(condition: GridConfigCondition, evt) {
    console.log('onCheckSuperFilter: ', evt.target.checked, condition);
    let {gridConfig, entities} = this.props;
    condition.superFilter = evt.target.checked;
  }


  @action onDeleteCondition(index) {
    console.log('onDeleteCondition: ', index);
    let {gridConfig} = this.props;
    gridConfig.conditions.splice(index, 1);
  }

  @action onChangeSortField(sort: GridConfigSort, newColKey) {
    newColKey = lovValue(newColKey);
    console.log('onChangeSortField: ', newColKey, sort);
    let {gridConfig} = this.props;
    sort.field = gridConfig.getEntityRef().getFieldByKey(newColKey);
  };

  @action onChangeSortOrder(sort, newOrder) {
    newOrder = lovValue(newOrder);
    console.log('onChangeSortOrder: ', newOrder, sort);
    let {gridConfig} = this.props;
    sort.sortOrder = newOrder;
  }

  @action onCheckSortFixed(sort, evt, checked) {
    console.log('onCheckSortFixed: checked = ' + checked);
    let {gridConfig} = this.props;
    sort.fixed = checked;
  };

  @action onClickAddSort = (evt) => {
    console.log('onClickAddSort');
    let {gridConfig} = this.props;

    let sort = new GridConfigSort(gridConfig, null);
    gridConfig.sortColumns.push(sort);
  };

  @action onDeleteSort(index) {
    console.log('onDeleteSort: ', index);
    let {gridConfig} = this.props;
    gridConfig.sortColumns.splice(index, 1);
  }

  @action handleSpecialCondition = (valueArray) => {
    let {gridConfig} = this.props;
    console.log('handleSpecialCondition %O', valueArray);
    gridConfig.specialConditions = valueArray;
    gridConfig.$dirty = true;
  };


  @action onChangeConfigLevel = (newConfigLevel: LovItem<CONFIGLEVEL>) => {
    let {gridConfig} = this.props;
    console.log('onChangeConfigLevel ' + newConfigLevel);
    gridConfig.configLevel = newConfigLevel;
    switch (newConfigLevel.value) {
      case CONFIGLEVEL.USER:
        gridConfig.tenantGroup = null;
        gridConfig.tenant = null;
        break;
      case CONFIGLEVEL.TENANT:
        gridConfig.user = null;
        gridConfig.tenantGroup = null;
        if (securityService.availableTenants.length === 1) gridConfig.tenant = securityService.availableTenants[0];
        break;
      case CONFIGLEVEL.TENANTGROUP:
        gridConfig.tenant = null;
        gridConfig.user = null;
        let tenantGroupLovs = this.tenantGroupLovs();
        if (tenantGroupLovs.length === 1) gridConfig.tenantGroup = tenantGroupLovs[0];
        break;
      case CONFIGLEVEL.GLOBAL:
        gridConfig.tenantGroup = null;
        gridConfig.tenant = null;
        gridConfig.user = null;
        break;
    }
  };

  @action onChangeTenantGroup = (tenantGroupLov) => {
    this.props.gridConfig.tenantGroup = tenantGroupLov;
  };
  @action onChangeTenant = (tenantLov) => {
    this.props.gridConfig.tenant = tenantLov;
  };

  extractFieldFn: TExtractFieldFn<GridConfigCondition> = (dataObject,fieldDef) => dataObject.field;


  tenantGroupLovs(): LovItem[] {
    let tgIds = new Set(securityService.availableTenants.map(lov => lov["tg"]));
    return mdEntityService.getEntity("TenantGroup").lovItems.filter( lov => tgIds.has(lov.value));
  }

  @action onClickDefineSelect = (evt) => {
    new Promise((resolve, reject) => {
      this.sqlSelectDialogRef.open(resolve, reject, this.props.gridConfig.sqlCommand, this.props.gridLocation);
    }).then((gridConfig: GridConfig) => {
      console.log('gridConfig: %O', gridConfig);
      this.props.gridConfig.columns = gridConfig.columns;
      this.props.gridConfig.sqlCommand = gridConfig.sqlCommand;
    }).catch((e) => {
    });

  };


  sqlSelectDialogRefHandler = comp => this.sqlSelectDialogRef = comp;

  /* ****************   REACT METHODS ************************************************************ */

  render() {
    let {
      grid,
      entities,
      gridConfig,
      gridLocation,
      adminMode,
      ...other
      } = this.props;

    console.debug('%c render - gridConfig %O', 'background-color: yellow', gridConfig);
    if (!gridConfig) return <noscript/>;


    let inputStyle = {fontSize: 14, marginRight: 20};

    let allOperators: LovItem[] = entities.get('FILTEROPERATOR').lovItems;

    let fieldOptions = (gridLocation.$entityRef) ? gridLocation.$entityRef.getFields().filter(field => field.filterable).map(field => ({value: field.fieldKey, label: field.label})) : [];

    let sortOrderOptions = [{value: 'ASC', label: loc.i18n`Ascending`}, {value: 'DESC', label: loc.i18n`Descending`}];

    let {configlevelOptions, disabled} = gridService.computeConfigLevels(gridLocation, gridConfig);

    let tenantGroupLovs = this.tenantGroupLovs();

    let indexLikeSortOrder: TIndex = {
      indexName: "gridSortOrder",
      columns: gridConfig.sortColumns.map(gcs => ({columnName: gcs.getFieldName(), sortOrder: gcs.sortOrder}))
    }
    let sortOrderIndexFound: boolean = this.indexes
      && !!this.indexes.filter(idx => isEqual(idx.columns.slice(0, indexLikeSortOrder.columns.length), indexLikeSortOrder.columns)).length;

    let sortOrderFilled = indexLikeSortOrder.columns.every(c => !!c.sortOrder && !!c.columnName);

    return (
          <form>
            <h4 style={{marginTop: 20}}>
              {(gridConfig.gridId) ? loc.i18n`Edit Grid` : loc.i18n`New Grid` }
            </h4>

            <ErrorComp messages={gridConfig.$errors}/>

            <BlockComp header={loc.i18n`1. Setup grid name`} style={{marginBottom: 30}}>
              <div style={{display: 'flex', whiteSpace: 'nowrap'}}>
                <div style={{display: 'flex', alignItems: 'baseline'}}>
                  <MdTextField name="gridName"
                             floatingLabelText={loc.i18n`Grid Name`}
                             style={inputStyle} required
                             errorText={gridConfig.$errorMap.get("gridName")}
                             value={gridConfig.gridName}
                             disabled={disabled}
                             onChange={this.onChangeTextField.bind(this, 'gridName', false)}
                             onBlur={this.onBlurGridConfigName}/>
                  <LocalizeField/>
                </div>
                <div style={{marginLeft: 30, alignSelf: 'flex-end', display: 'flex', alignItems: 'flex-end', width: "100%"}}>

                  <RadioButtonField name="configLevelRB" value={gridConfig.configLevel} onChange={this.onChangeConfigLevel} options={configlevelOptions}
                                    groupStyle={{display: 'flex'}} optionStyle={{width: 'initial', marginRight: 15}}
                                    labelStyle={{whiteSpace: 'nowrap', marginLeft: -10}}
                                    style={{marginBottom:5}} disabled={disabled}/>


                  { (lovValue(gridConfig.configLevel) === CONFIGLEVEL.TENANTGROUP) ?
                      <StyledSelect {...fieldStyles.small.styledSelect} name="tenantGroupS" value={gridConfig.tenantGroup}
                                    options={tenantGroupLovs} fullWidth={true}
                                    onChange={this.onChangeTenantGroup} clearable={false} disabled={disabled}/>
                    : null}

                  { (lovValue(gridConfig.configLevel) === CONFIGLEVEL.TENANT) ?
                    <StyledSelect {...fieldStyles.small.styledSelect} name="tenantS" value={gridConfig.tenant}
                                  options={securityService.availableTenants} fullWidth={true}
                                  onChange={this.onChangeTenant} clearable={false} disabled={disabled}/>
                    : null}


                </div>
              </div>
            </BlockComp>

            <MdDivider marginBottom={20}/>

            { (gridLocation.gridType === GRIDTYPE.SQLQUERY) ? (

              <BlockComp header={loc.i18n`2. SQL Report`} style={{marginBottom: 30}}>
                <RaisedButton label={loc.i18n`Define SQL select`} onClick={this.onClickDefineSelect} primary disabled={disabled} style={{marginBottom: 30}}/>
                <SqlSelectDialog ref={this.sqlSelectDialogRefHandler} title="SQL select"/>
                <table className="zz-simple-table">
                  <thead>
                    <tr>
                      <th>Column</th>
                      <th>Type</th>
                      <th>Number format</th>
                      <th>Text align</th>
                      <th>Search Term</th>
                    </tr>
                  </thead>
                  <tbody>
                    {gridConfig.columns.map((c,i) => {
                      let operatorOptions = (c.field && c.field.availableOperators) ? allOperators
                        .filter(li => c.field.availableOperators.includes(li.value as FILTEROPERATOR)) : [];

                      return <tr key={i}>
                      <td>{c.field.label}</td>
                      <td>{c.field.dataType}</td>
                      <td>{c.field.numberFormat}</td>
                      <td>{c.field.textAlign}</td>
                      <td>
                        <StyledSelect {...fieldStyles.small.styledSelect} name="searchTermType" value={c.field.searchTermType} options={operatorOptions}  fullWidth={true}
                                      onChange={this.onChangeSearchTermOperator.bind(this, c.field)}
                                      clearable={true}  />
                      </td>
                    </tr>
                    })}
                  </tbody>
                </table>
              </BlockComp>

            ) : (
              <BlockComp header={loc.i18n`2. Choose Grid Columns`} style={{marginBottom: 30}}>
                <ColumnSelector gridConfig={gridConfig}  entity={gridLocation.$entityRef} disabled={disabled} />
              </BlockComp>
            )}

            <MdDivider marginBottom={20}/>

            { (gridLocation.gridType !== GRIDTYPE.SQLQUERY) ? (
            <BlockComp header={loc.i18n`3. Setup Filters`} style={{marginBottom: 30}}>
              <table className="table">
                <thead>
                <tr>
                  <td style={{width: '27%'}}>{loc.i18n`Column Name`}</td>
                  <td style={{width: '17%'}}>{loc.i18n`Operator`}</td>
                  <td style={{width: '44%'}}>{loc.i18n`Value`}</td>
                  <td style={{width: '9%'}}>{loc.i18n`Sticky`}</td>
                  <td style={{width: '3%'}}/>
                </tr>
                </thead>
                <tbody>
                {
                  gridConfig.conditions.map((condition: GridConfigCondition, index) => {
                    let operatorOptions = (condition.field) ? allOperators
                      .filter(li => condition.field.availableOperators.includes(li.value as FILTEROPERATOR)) : [];

                    let borderStyle = (index > 0) ? {borderTop: 'inherit'} : {};

                    return (
                      <tr key={index}>
                        <td style={borderStyle}>
                          <StyledSelect {...fieldStyles.small.styledSelect} name="conditionColumn" value={condition.fieldKey} options={fieldOptions} fullWidth={true}
                                        onChange={this.onChangeConditionColumn.bind(this, condition)} clearable={false}
                                        disabled={condition.implicit || disabled} />
                        </td>
                        <td style={borderStyle}>
                          <StyledSelect {...fieldStyles.small.styledSelect} name="conditionOperator" value={condition.operator} options={operatorOptions}  fullWidth={true}
                                        onChange={this.onChangeConditionOperator.bind(this, condition)}
                                        clearable={false} disabled={condition.implicit || disabled} />
                        </td>
                        <td style={borderStyle}>
                          { (condition.field) ?
                          <ConditionValueForm  dataObject={condition} rootObject={gridConfig} entities={entities} disabled={condition.implicit || disabled} context={CONDITIONVALUEFORMCONTEXT.GRIDDEF}
                                              entity={condition.getEntityRef()} extractFieldFn={this.extractFieldFn} />
                            :
                            null
                          }
                        </td>
                        <td style={borderStyle}>
                          <MdCheckbox {...fieldStyles.small.checkbox} name="superFilter" value={condition.superFilter} onCheck={this.onCheckSuperFilter.bind(this, condition)}
                                    defaultChecked={condition.superFilter}  disabled={condition.implicit || disabled} />
                        </td>
                        <td style={Object.assign(borderStyle, {verticalAlign: 'middle'})}>
                          {
                            (condition.implicit || disabled) ? '' : (
                              <a className="font-button-link" onClick={this.onDeleteCondition.bind(this, index)}>
                                <span className="fa fa-trash"/>
                              </a>
                            )
                          }
                        </td>

                      </tr>
                    );
                  })
                }
                </tbody>
              </table>
              <RaisedButton
                label={loc.i18n`Add Filter`}
                onClick={this.onClickAddFilter}
                primary
                disabled={disabled}
                icon={<Add />}
              />

            </BlockComp>
            ) : null }

            { (gridLocation.specialConditions.length) ? (
              <BlockComp header={loc.i18n`4. Special Conditions`} style={{marginTop: 30, marginBottom: 5}}>
                  <div className="row">
                    <div className="col-xs-12">
                      <StyledSelect {...fieldStyles.small.styledSelect}
                                    onChange={this.handleSpecialCondition} value={gridConfig.specialConditions}
                                    options={gridLocation.specialConditions} disabled={disabled}
                                    multi fullWidth searchable={false} clearable={false}/>
                    </div>
                  </div>
              </BlockComp>
            ) : null }



            { (gridLocation.gridType !== GRIDTYPE.SQLQUERY) ? (
            <MdDivider marginBottom={20}/>
            ) : null }

            { (gridLocation.gridType !== GRIDTYPE.SQLQUERY) ? (
            <BlockComp header={loc.i18n`5. Setup Grid Ordering`} style={{marginBottom: 30}}>

              {gridConfig.sortColumns.length && !sortOrderIndexFound && this.indexes && sortOrderFilled &&
                (
                  <ErrorComp bsStyle="warning"  header="Current ordering is not supported by appropriate index. Performance will be less than ideal. Existing indexes: " messages={this.indexes.map(idx => ({message: idx.columns.map(c => c.columnName + " " + c.sortOrder).join(", ")}))}/>
                )
              }

              <table className="table">
                <thead>
                <tr>
                  <td style={{width: '40%'}}>{loc.i18n`Column Name`}</td>
                  <td style={{width: '30%'}}>{loc.i18n`ASC / DESC`}</td>
                  <td style={{width: '25%'}}>{loc.i18n`Lock Ordering`}</td>
                  <td style={{width: '5%'}}/>
                </tr>
                </thead>
                <tbody>
                {
                  gridConfig.sortColumns.map((sort: GridConfigSort, index) => {

                    let borderStyle = (index > 0) ? {borderTop: 'inherit'} : {};

                    return (
                      <tr key={index}>
                        <td style={borderStyle}>
                          <StyledSelect {...fieldStyles.small.styledSelect} name="sortColumn" value={sort.fieldKey} options={fieldOptions}
                                        onChange={this.onChangeSortField.bind(this, sort)} clearable={false} disabled={disabled}/>
                        </td>
                        <td style={borderStyle}>
                          <StyledSelect {...fieldStyles.small.styledSelect} name="sortOrder" value={sort.sortOrder} options={sortOrderOptions}
                                        onChange={this.onChangeSortOrder.bind(this, sort)} clearable={false} disabled={disabled}/>
                        </td>
                        <td style={Object.assign(borderStyle, {verticalAlign: 'middle'})}>
                          <MdCheckbox style={Object.assign({marginTop: 10}, fieldStyles.small.default)}  name="sortFixed" value={new Boolean(sort.fixed).toString()}
                                    defaultChecked={sort.fixed} label="Fixní řazení"
                                    onCheck={this.onCheckSortFixed.bind(this, sort)} disabled={disabled}/>
                        </td>
                        <td style={Object.assign(borderStyle, {verticalAlign: 'middle'})}>
                          {(disabled) ? '' : (<a className="font-button-link" onClick={this.onDeleteSort.bind(this, index)}><span
                            className="fa fa-trash"/></a>) }
                        </td>

                      </tr>
                    );
                  })
                }
                </tbody>
              </table>
              <RaisedButton
                label={loc.i18n`Add Ordering`}
                onClick={this.onClickAddSort}
                primary
                disabled={disabled}
                icon={<Add />}
              />

            </BlockComp>
            ) : null }


            {(adminMode)? (<MdDivider marginBottom={20}/>) : null }

            {(adminMode || gridLocation.gridType === GRIDTYPE.SQLQUERY)?(
              <BlockComp header="6. Advanced options" style={{marginBottom: 30}}>
                <div style={{display: 'flex'}}>
                  <MdTextField name="gridScrollSize"
                               floatingLabelText="Max scroll Size"
                               style={inputStyle} required errorText={gridConfig.$errorMap.get("gridScrollSize")}
                               value={gridConfig.gridScrollSize}
                               onChange={this.onChangeTextField.bind(this, 'gridScrollSize', true)}
                               onBlur={this.onBlurGridScrollSize} disabled={disabled}/>
                  <MdTextField name="gridPageSize"
                               floatingLabelText="Page Size"
                               style={inputStyle} required errorText={gridConfig.$errorMap.get("gridPageSize")}
                               value={gridConfig.gridPageSize}
                               onChange={this.onChangeTextField.bind(this, 'gridPageSize', true)}
                               onBlur={this.onBlurGridPageSize} disabled={disabled || gridLocation.editable || gridLocation.gridType === GRIDTYPE.JAVACONFIG}/>
                  <MdTextField name="maxColumnWidth"
                               floatingLabelText="Max column width"
                               style={inputStyle} required errorText={gridConfig.$errorMap.get("maxColumnWidth")}
                               value={gridConfig.maxColumnWidth}
                               onChange={this.onChangeTextField.bind(this, 'maxColumnWidth', true)}
                               onBlur={this.onBlurMaxColumnWidth} disabled={disabled}/>
                </div>
                <div style={{display: 'flex'}}>
                  <MdTextField name="hardRowLimit"
                               floatingLabelText="Hard row limit"
                               style={inputStyle} errorText={gridConfig.$errorMap.get("hardRowLimit")}
                               value={gridConfig.hardRowLimit}
                               onChange={this.onChangeTextField.bind(this, 'hardRowLimit', true)}
                               onBlur={this.onBlurHardRowLimit()} disabled={disabled}/>

                  <MdCheckbox name="refreshOnPage"
                              label="Refresh on page load"
                              style={ {...inputStyle, ...{marginTop: 30}} }
                              checked={gridConfig.refreshOnPage}
                              onCheck={this.onChangeCheckbox.bind(this, 'refreshOnPage')}
                              disabled={disabled}/>
                  <MdCheckbox name="refreshOnData"
                              label="Refresh on data change"
                              style={ {...inputStyle, ...{marginTop: 30}} }
                              checked={gridConfig.refreshOnData}
                              onCheck={this.onChangeCheckbox.bind(this, 'refreshOnData')}
                              disabled={disabled}/>
                </div>

                <div style={{display: 'flex'}}>
                  <StyledSelect {...fieldStyles.small.styledSelect} name="gridRowCss"
                                floatingLabelText="Grid Row CSS"
                                onChange={this.onChangeSelect.bind(this, 'gridRowCss')}
                                value={gridConfig.gridRowCss}
                                options={mdEntityService.getEntity("GRIDROWCSS").lovItems} disabled={disabled}
                                searchable={false} clearable={false}/>
                </div>

              </BlockComp>
            ):null}


          </form>
    );
  }

}




// WEBPACK FOOTER //
// ./src/core/grid/component/gridAdminComp.tsx